var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomerenovation1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.74945H16.75V6.99945L9.4175 1.37695C9.29399 1.29419 9.14867 1.25 9 1.25C8.85133 1.25 8.70601 1.29419 8.5825 1.37695L1.25 6.99945V8.74945H2.25V16.2494C2.25 16.3821 2.30268 16.5092 2.39645 16.603C2.49021 16.6968 2.61739 16.7494 2.75 16.7494H15.25C15.3826 16.7494 15.5098 16.6968 15.6036 16.603C15.6973 16.5092 15.75 16.3821 15.75 16.2494V8.74945Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2.5V1.5H15.75V4.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 6.75V8.25H10.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14V12.5H7.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32501 11C5.27458 10.7532 5.24945 10.5019 5.25001 10.25C5.25001 9.46294 5.49765 8.69583 5.95785 8.05734C6.41805 7.41884 7.06749 6.94133 7.81416 6.69244C8.56083 6.44355 9.36688 6.4359 10.1181 6.67057C10.8694 6.90525 11.5278 7.37035 12 8",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7175 9.75C12.7385 9.91585 12.7494 10.0828 12.75 10.25C12.75 11.0095 12.5194 11.751 12.0887 12.3765C11.658 13.002 11.0476 13.4821 10.3381 13.753C9.62864 14.024 8.85363 14.0732 8.1156 13.8941C7.37757 13.715 6.71132 13.316 6.205 12.75C6.1325 12.67 6.065 12.5875 6 12.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomerenovation1);
export default __webpack_public_path__ + "static/media/home renovation-1.0b4eba30.svg";
export { ForwardRef as ReactComponent };